<template>
  <div class="safelog">
    <el-row>
      <!-- 工具条 -->
      <el-form :inline="true" class="demo-form-inline toolbar" style="padding-bottom:0px;">
        <el-form-item label>
          <kt-button label="上一天" type="primary" @click="handlePrevDay" />
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            :editable="false"
            :clearable="false"
            v-model="dateValue"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="pickerTime" 
            @change="changeDate"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            v-if="showNextDayBtn"
            label="下一天"
            type="primary"
            @click="handleNextDay"
          />
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-input
          v-model.trim="safeLog"
          :disabled="safeLogDisabled"
          type="textarea"
          :rows="23"
          placeholder="填写每日的安全检查记录"
        ></el-input>
      </el-col>
    </el-row>
    <el-row v-if="showRowbtn">
      <div align="center" style="margin:20px 0 30px 0;">
        <el-button
          v-if="showBtn"
          type="warning"
          :size="size"
          @click.native="handleEdit"
        >编辑</el-button>
        <el-button
          v-else
          type="primary"
          :size="size"
          @click.native="handleSure"
          :loading="submitLoading"
        >保存</el-button>
      </div>
    </el-row>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  name: "SafeLog",
  components: { KtButton },
  data() {
    return {
      size: "medium", //按钮的尺寸
      dateValue: util.formatDate.format(new Date(), "yyyy-MM-dd"),
      submitLoading: false, //提交按钮的loading
      showRowbtn:true,//按钮是否显示还是隐藏
      showBtn: true, //编辑和保存按钮的显示和隐藏
      safeLog: "",//安全检查日志提交的数据
      safeLogDisabled:true,//安全检查日志的文本域是否可以编辑
      showNextDayBtn:false,//默认是隐藏的
      flagSafeLog:false,
      //不能选择今天以后的日期
      pickerTime: {
        disabledDate: time => {
          let nowData = new Date();
          // nowData = new Date(nowData.setDate(nowData.getDate() - 1));//不能选择今天的日期
          nowData = new Date(nowData.setDate(nowData.getDate()));//可以选择今天的日期
          return time >= nowData;
        }
      }
    };
  },
  methods: {
    /* 
      时间选择框的change事件
    */
    changeDate(val) {
      console.log(val);
      this.dateValue=val;
      var nowDay=new Date();//获取今天的时间
      var year = nowDay.getFullYear();
      var month = nowDay.getMonth() + 1;
      var day = nowDay.getDate();
      var dateX = year + "-" + month + "-" + day; //获取当前的日期
      var pickTime = new Date(this.dateValue).getTime(); //事件选择器中的时间戳
      var nowTimeX = new Date(dateX).getTime(); //今天的时间戳
      console.log(pickTime, nowTimeX, "比较时间戳");
      //选取的时间小于今天的时间  下一天的按钮显示  否则就隐藏
      this.showNextDayBtn = pickTime < nowTimeX ? true : false;//下一天按钮的显示和隐藏
      this.showRowbtn = pickTime < nowTimeX ? false : true;//编辑和保存按钮的显示和隐藏
      this.safeLogDisabled=true;//文本域不可以编辑
      this.showBtn=true;//编辑按钮显示 保存按钮隐藏
      this.selectByDate(this.dateValue); //刷洗数据
    },

    /* 
      上一天
    */
    handlePrevDay() {
      // 获得当前日期
      var doday = new Date(this.dateValue);//时间选择器中的时间
      var nowDay= new Date();//今天de的时间
      var year =nowDay.getFullYear();
      var month=nowDay.getMonth()+1;
      var day=nowDay.getDate();
      var dateX=year+'-'+month+'-'+day;//获取当前的日期
      console.log(doday,dateX);
      doday = Date.parse(doday);
      console.log(doday);
      // 将当前日期减去1天的时间
      doday = doday - 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      console.log(nowDate);
      // 获得value
      this.dateValue = nowDate;
      console.log(this.dateValue);
      var pickTime=new Date(this.dateValue).getTime();//事件选择器中的时间戳
      var nowTimeX=new Date(dateX).getTime();//今天的时间戳
      console.log(pickTime,nowTimeX,"比较时间戳");
      //选取的时间小于今天的时间  下一天的按钮显示  否则就隐藏
      this.showNextDayBtn= pickTime<nowTimeX ? true : false;//下一天按钮的显示和隐藏
      this.showRowbtn=pickTime<nowTimeX ? false : true;//编辑和保存按钮的显示和隐藏
      this.safeLogDisabled=true;//文本域不可以编辑
      this.showBtn=true;//编辑按钮显示 保存按钮隐藏
      this.selectByDate(this.dateValue);//刷洗数据
    },

    /* 
      下一天
    */
    handleNextDay() {
      // 获得当前日期
      var doday = new Date(this.dateValue);//时间选择器中的时间
      var nowDay= new Date();//今天de的时间
      var year =nowDay.getFullYear();
      var month=nowDay.getMonth()+1;
      var day=nowDay.getDate();
      var dateX=year+'-'+month+'-'+day;//获取当前的日期
      console.log(doday,nowDate);
      doday = Date.parse(doday);
      // 将当前日期加上1天的时间
      doday = doday + 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      console.log(nowDate);
      // 获得value
      this.dateValue = nowDate;
      console.log(this.dateValue,);
      var pickTime=new Date(this.dateValue).getTime();//事件选择器中的时间戳
      var nowTimeX=new Date(dateX).getTime();//今天的时间戳
      console.log(pickTime,nowTimeX,"比较时间戳");
      //选取的时间大于等于今天的时间  下一天的按钮隐藏  否则就显示
      this.showNextDayBtn= pickTime>=nowTimeX ? false : true;//下一天按钮的显示和隐藏
      this.showRowbtn=pickTime==nowTimeX ? true : false;//编辑和保存按钮的显示和隐藏
      this.safeLogDisabled=true;//文本域不可以编辑
      this.showBtn=true;//编辑按钮显示 保存按钮隐藏
      this.selectByDate(this.dateValue);//刷洗数据
    },

    /* 
      工作日志--编辑
    */
    handleEdit() {
      this.safeLogDisabled=false;//文本域可以输入
      this.showBtn=false;//保存按钮显示  编辑按钮隐藏
      this.safeLog=this.flagSafeLog==true ? this.safeLog : '';
    },

    /* 
      工作日志--保存
    */
    handleSure() {
      if(this.safeLog.length<=1000){
        let params=new Object();
        params.date=this.dateValue;//日期
        params.safeLog=this.safeLog!='' ? this.safeLog : ' ';//为了避免不填请求数据报错  因为就传空格字符串 
        this.submitLoading = true;
        this.$postJson("omc/safeLog/save", params).then(res => {
          console.log(res);
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
          } else {
            this.$message({ message: res.message, type: "error" });
          }
          this.submitLoading = false;
          this.safeLogDisabled=true;//文本域不可输入
          this.showBtn=true;//编辑按钮显示  保存按钮隐藏
          this.selectByDate(this.dateValue);//刷洗数据
        });
      }else{
        this.$message({message:'安全检查日志长度不能超过1000个字符',type:'error'});
      }
    },

    /* 
      工作日志--按日期查询
    */
    selectByDate(date) {
      console.log(date);
      this.$postForm('omc/safeLog/showByDate/'+date).then(res=>{
        if (res.code == 200) {
          if(res.result!=null){
            let safeLog=res.result.safeLog.replace(/\s*/g,'');//获取结果并去除空格;
            this.safeLog=safeLog!='' ? safeLog : '暂无记录';
            this.flagSafeLog=safeLog!='' ? true : false;
          }else{
            this.safeLog='暂无记录';
            this.flagSafeLog=false;
          }
        }
      })
    },
  },
  created() {},
  mounted() {
    this.selectByDate(this.dateValue); //按日期查询工作日志
  }
};
</script>
<style lang="scss" scoped>
.safelog {
  width: 100%;
  height: 100%;
  background: #fefefe;
}
</style>
